import { styled } from '@mui/material/styles';
import Paper from '@mui/material/Paper';

/**
 * Styled Paper used throughout dataset/admin views as a content card.
 * Matches the visual language of the Overview/Inspector tab so that
 * the Admin tab feels at home with the rest of the app.
 */
export const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: theme.palette.secondary.main,
    ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: 'left',
    color: theme.palette.text.main
}));

/** True if the user has admin or owner role on the given dataset shape. */
export const isAdmin = (ds) => ['owner', 'admin'].includes(ds?.AccessRole);

/** True if the user is the owner of the given dataset shape. */
export const isOwner = (ds) => ds?.AccessRole === 'owner';

/**
 * Formats a byte count for human display. 1024-base, two-decimal precision,
 * trims trailing zeros. Used in the MQTT info panel where raw byte numbers
 * (e.g. 209715200) read like noise.
 */
export const formatBytes = (n) => {
    if (typeof n !== 'number' || !Number.isFinite(n) || n < 0) return String(n);
    if (n < 1024) return `${n} B`;
    const units = ['KB', 'MB', 'GB', 'TB'];
    let i = -1;
    let value = n;
    do {
        value /= 1024;
        i += 1;
    } while (value >= 1024 && i < units.length - 1);
    const rounded = value >= 100 ? value.toFixed(0) : value.toFixed(2).replace(/\.?0+$/, '');
    return `${rounded} ${units[i]}`;
};
